var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyTransfer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_562_money_transfer_outline",
    "data-name": "#562_money_transfer_outline"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.13,
    y: 76.82,
    width: 84.54,
    height: 146.36,
    rx: 7.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,224.18H124.81a8.69,8.69,0,0,1-8.68-8.68V84.5a8.69,8.69,0,0,1,8.68-8.68H194a8.69,8.69,0,0,1,8.68,8.68v131A8.69,8.69,0,0,1,194,224.18ZM124.81,77.82a6.69,6.69,0,0,0-6.68,6.68v131a6.69,6.69,0,0,0,6.68,6.68H194a6.69,6.69,0,0,0,6.68-6.68V84.5A6.69,6.69,0,0,0,194,77.82Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.92,218.49a6.17,6.17,0,1,1,6.17-6.17A6.18,6.18,0,0,1,158.92,218.49Zm0-10.34a4.17,4.17,0,1,0,4.17,4.17A4.17,4.17,0,0,0,158.92,208.15Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.13,
    y: 88.01,
    width: 84.54,
    height: 113.98,
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.67,203H117.13a1,1,0,0,1-1-1V88a1,1,0,0,1,1-1h84.54a1,1,0,0,1,1,1V202A1,1,0,0,1,201.67,203Zm-83.54-2h82.54V89H118.13Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.2,83.6h-1.72a1,1,0,0,1,0-2h1.72a1,1,0,0,1,0,2Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.32,83.6h-7.75a1,1,0,0,1,0-2h7.75a1,1,0,0,1,0,2Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.55,
    y: 88.27,
    width: 71.32,
    height: 123.46,
    rx: 6.48,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.39,212.73H218a7.49,7.49,0,0,1-7.48-7.48V94.75A7.49,7.49,0,0,1,218,87.27h58.36a7.48,7.48,0,0,1,7.48,7.48v110.5A7.48,7.48,0,0,1,276.39,212.73ZM218,89.27a5.49,5.49,0,0,0-5.48,5.48v110.5a5.49,5.49,0,0,0,5.48,5.48h58.36a5.49,5.49,0,0,0,5.48-5.48V94.75a5.49,5.49,0,0,0-5.48-5.48Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.81,207.94a5.37,5.37,0,1,1,5.36-5.37A5.37,5.37,0,0,1,246.81,207.94Zm0-8.73a3.37,3.37,0,1,0,3.36,3.36A3.36,3.36,0,0,0,246.81,199.21Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.55,
    y: 97.7,
    width: 71.32,
    height: 96.15,
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.87,194.85H211.55a1,1,0,0,1-1-1V97.7a1,1,0,0,1,1-1h71.32a1,1,0,0,1,1,1v96.15A1,1,0,0,1,282.87,194.85Zm-70.32-2h69.32V98.7H212.55Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.67,94.14h-1.46a1,1,0,0,1,0-2h1.46a1,1,0,0,1,0,2Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.21,94.14h-6.54a1,1,0,0,1,0-2h6.54a1,1,0,0,1,0,2Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "187.31 131.82 220.04 131.82 220.04 116.05 254.89 145 220.04 173.94 220.04 158.17 187.31 158.17",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,174.94a.94.94,0,0,1-.43-.1,1,1,0,0,1-.57-.9V159.17H187.31a1,1,0,0,1,0-2H220a1,1,0,0,1,1,1v13.64L253.32,145,221,118.18v13.64a1,1,0,0,1-1,1H187.31a1,1,0,0,1,0-2H219V116.05a1,1,0,0,1,.57-.9,1,1,0,0,1,1.07.13l34.85,28.95a1,1,0,0,1,0,1.53l-34.85,29A1,1,0,0,1,220,174.94Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.69,159.57v-4.06c-1.48-.4-2.92-.71-4.3-1.18a12.55,12.55,0,0,1-6.61-5,12.29,12.29,0,0,1-1.91-6.88h7.93c.37,2.95,1.8,5.06,4.86,5.88V137.6c-1.59-.46-3.18-.89-4.75-1.39a11,11,0,0,1-4.61-2.63,9.07,9.07,0,0,1-2.56-5,12.81,12.81,0,0,1,.5-6.91,11.49,11.49,0,0,1,7-6.9,35.69,35.69,0,0,1,4-1c.14,0,.29-.06.48-.1v-5.38h7.41v.52c0,1.54,0,3.08,0,4.62,0,.38.12.5.49.57a15.71,15.71,0,0,1,6.91,3.23,11.18,11.18,0,0,1,3.93,6.89c.13.73.19,1.48.28,2.26h-8.06a5.64,5.64,0,0,0-3.49-5.11v10l.87.21a28.21,28.21,0,0,1,6.32,2,9.16,9.16,0,0,1,5.48,7.64,12,12,0,0,1-2.09,8.75,12.17,12.17,0,0,1-6,4.43c-1.49.51-3,.86-4.64,1.3v3.93Zm7.44-20.42v9.35a6.79,6.79,0,0,0,3.28-1.45c1.72-1.41,2.33-4.93-.19-6.48A29.4,29.4,0,0,0,163.13,139.15Zm-7.47-9.58v-9a25.75,25.75,0,0,0-2.83,1.45c-2.06,1.37-2.39,5.18.24,6.51C153.88,128.91,154.75,129.2,155.66,129.57Z",
    fill: "#ffbc0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.11,160.57h-7.42a1,1,0,0,1-1-1v-3.29l-.63-.16c-1-.25-2-.51-3-.85a13.51,13.51,0,0,1-7.11-5.35,13.22,13.22,0,0,1-2.08-7.42,1,1,0,0,1,.29-.71,1,1,0,0,1,.71-.3h7.93a1,1,0,0,1,1,.88c.28,2.26,1.2,3.74,2.87,4.56v-8.57l-.73-.21c-1.11-.32-2.22-.64-3.32-1a11.94,11.94,0,0,1-5-2.87,10.15,10.15,0,0,1-2.85-5.53,13.63,13.63,0,0,1,.55-7.43,12.44,12.44,0,0,1,7.54-7.48,20.83,20.83,0,0,1,2.9-.79l.95-.22v-4.57a1,1,0,0,1,1-1h7.41a1,1,0,0,1,1,1V110q0,1.51,0,3a16.58,16.58,0,0,1,7,3.37,12.17,12.17,0,0,1,4.28,7.49c.09.52.15,1,.21,1.58l.08.73a1,1,0,0,1-.25.78,1,1,0,0,1-.74.34h-8.07a1,1,0,0,1-1-.94,4.56,4.56,0,0,0-1.49-3.35v7.43l.07,0a29.1,29.1,0,0,1,6.54,2.09,10.15,10.15,0,0,1,6.05,8.43,13,13,0,0,1-8.74,14.24c-1.06.37-2.16.66-3.23.93l-.73.19v3.17A1,1,0,0,1,163.11,160.57Zm-6.42-2h5.42v-2.93a1,1,0,0,1,.73-1l1.5-.39c1.08-.28,2.09-.54,3.08-.89a11.15,11.15,0,0,0,5.5-4.07,10.88,10.88,0,0,0,1.9-8,8.13,8.13,0,0,0-4.91-6.86,27.06,27.06,0,0,0-6.1-1.94l-.64-.16-.26-.06a1,1,0,0,1-.76-1v-10a1,1,0,0,1,1.42-.91,6.55,6.55,0,0,1,4,5h6.06c-.05-.37-.09-.73-.15-1.09a10.14,10.14,0,0,0-3.59-6.29,14.57,14.57,0,0,0-6.48-3,1.47,1.47,0,0,1-1.28-1.57c0-1.11,0-2.23,0-3.35v-.77h-5.41v4.38a1,1,0,0,1-.8,1l-.19,0-.25,0-1.28.29a19.62,19.62,0,0,0-2.62.71,10.53,10.53,0,0,0-6.38,6.32,11.82,11.82,0,0,0-.45,6.37,8.06,8.06,0,0,0,2.29,4.46,9.82,9.82,0,0,0,4.2,2.39c1.09.34,2.18.65,3.27,1l1.46.41a1,1,0,0,1,.72,1v10.77a1,1,0,0,1-1.26,1,7.1,7.1,0,0,1-5.45-5.84h-6a10.89,10.89,0,0,0,1.71,5.33,11.38,11.38,0,0,0,6.09,4.56c.91.31,1.85.55,2.84.8l1.4.37a1,1,0,0,1,.74,1Zm6.44-9.07a1.06,1.06,0,0,1-.65-.24,1,1,0,0,1-.35-.76v-9.35a1,1,0,0,1,1.41-.91l1,.42a16.43,16.43,0,0,1,2.2,1.06,4.47,4.47,0,0,1,2.16,3.6,5.47,5.47,0,0,1-1.85,4.5,7.71,7.71,0,0,1-3.76,1.66Zm1-8.84v6.55a5.52,5.52,0,0,0,1.65-.94,3.5,3.5,0,0,0,1.12-2.82,2.46,2.46,0,0,0-1.2-2A12.07,12.07,0,0,0,164.13,140.66Zm-8.47-10.09a1,1,0,0,1-.38-.07l-.84-.33a17.79,17.79,0,0,1-1.82-.78,4.39,4.39,0,0,1-2.42-3.78,5,5,0,0,1,2.07-4.46,15.49,15.49,0,0,1,2-1.06c.31-.14.62-.28.93-.44a1,1,0,0,1,1,0,1,1,0,0,1,.48.85v9a1,1,0,0,1-1,1Zm-1-8.45a10.34,10.34,0,0,0-1.28.7,3,3,0,0,0-1.18,2.67,2.45,2.45,0,0,0,1.32,2.12c.36.18.74.34,1.14.5Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.27,
    y: 175.27,
    width: 56.27,
    height: 13.18,
    rx: 6.59,
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.55,180.44h-1.78v-1.13h4.87v1.13h-1.79v4h-1.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.89,184.41h-1.45l-1.07-1.69h-.84v1.69h-1.3v-5.1H147a1.68,1.68,0,0,1,1.9,1.69,1.59,1.59,0,0,1-1.18,1.61h0Zm-2-2.8c.44,0,.71-.21.71-.61s-.24-.59-.71-.59h-1.33v1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1,183.65h-2.45l-.31.76H149l2.28-5.1h1.2l2.28,5.1h-1.34Zm-.45-1.1-.77-1.86h0l-.77,1.86Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.15,179.31h1.35l2.25,3.24h0v-3.24h1.3v5.1H158.7l-2.24-3.25h0v3.25h-1.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.62,182.69l1.23-.22a1.19,1.19,0,0,0,1.37,1c.6,0,1-.18,1-.5s-.26-.46-1.5-.73-1.89-.75-1.89-1.54.85-1.55,2.13-1.55a2.28,2.28,0,0,1,2.39,1.56l-1.23.27a1.11,1.11,0,0,0-1.16-.78c-.51,0-.83.19-.83.48s.24.35,1.42.62,2,.77,2,1.64-.88,1.58-2.26,1.58S160.8,183.87,160.62,182.69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,179.31h4v1.13h-2.68v1.14h2.58v1.08h-2.58v1.75H166Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7,179.31h3.94v1.13H172v.86h2.39v1H172v.94h2.64v1.13H170.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,184.41h-1.44l-1.07-1.69h-.85v1.69h-1.3v-5.1h2.74A1.69,1.69,0,0,1,180,181a1.59,1.59,0,0,1-1.18,1.61h0Zm-2-2.8c.44,0,.72-.21.72-.61s-.25-.59-.72-.59h-1.33v1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.83,105.27a1,1,0,0,1-1-1v-4.13a1,1,0,0,1,2,0v4.13A1,1,0,0,1,134.83,105.27Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.83,115a1,1,0,0,1-1-1V109.9a1,1,0,0,1,2,0V114A1,1,0,0,1,134.83,115Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.77,108.09h-4.13a1,1,0,0,1,0-2h4.13a1,1,0,0,1,0,2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,108.09h-4.13a1,1,0,0,1,0-2H132a1,1,0,0,1,0,2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.31,117.93a1,1,0,0,1-1-1V114a1,1,0,0,1,2,0v2.9A1,1,0,0,1,187.31,117.93Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.31,124.79a1,1,0,0,1-1-1v-2.9a1,1,0,1,1,2,0v2.9A1,1,0,0,1,187.31,124.79Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.19,119.91h-2.9a1,1,0,0,1,0-2h2.9a1,1,0,0,1,0,2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.34,119.91h-2.91a1,1,0,0,1,0-2h2.91a1,1,0,0,1,0,2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.24,153.11a1,1,0,0,1-1-1v-2.9a1,1,0,0,1,2,0v2.9A1,1,0,0,1,133.24,153.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.24,160a1,1,0,0,1-1-1v-2.9a1,1,0,0,1,2,0V159A1,1,0,0,1,133.24,160Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.12,155.09h-2.9a1,1,0,0,1,0-2h2.9a1,1,0,0,1,0,2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.27,155.09h-2.91a1,1,0,0,1,0-2h2.91a1,1,0,0,1,0,2Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyTransfer);
export default __webpack_public_path__ + "static/media/moneyTransfer.5fc5f4b607f002f76eb370894f843316.svg";
export { ForwardRef as ReactComponent };